import { render, staticRenderFns } from "./detected_face.vue?vue&type=template&id=4dd583bd"
import script from "./detected_face.vue?vue&type=script&lang=js"
export * from "./detected_face.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports